import React, { Component } from 'react';
import {
    // Breadcrumb,
    // BreadcrumbItem,
    Button,
    ButtonGroup,
    Col,
    Container,
    FormGroup,
    Label,
    Row,
    Collapse, CardBody, Card, Modal, ModalHeader, ModalBody
    // CardTitle
} from "reactstrap";
import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import { ALIBABA_URL } from "../../config/Config";
import qs from "qs";
import axios from "axios";
import { toast } from "react-toastify";
import { ACCESS_TOKEN } from "../../redux/actions/setting";
import Checkbox from '@material-ui/core/Checkbox';
// import AirplaneSearchForm from "../../components/search/AirplaneSearchForm";
import { airlines_selected, airlines } from "../../redux/utils/airlines";
import SaveLoader from "../../components/loader/SaveLoader";
import Steppers from "../../components/search/Steppers";
import FlightItem from "../../components/search/FlightItem";

import * as moment from 'moment';
import 'moment-timezone';
// import SectionLoader from "../../components/loader/SectionLoader";
import PriceFormatter from "../../components/misc/PriceFormatter";
import BannerLink from "../../components/banner/Banner-link";
import { setSearch } from "../../redux/actions/search";


import { airports } from "../../redux/utils/airports";

class Search extends Component {
    constructor(props) {
        super(props);
        this._handleFilterd.bind(this);
        this.calculateDates.bind(this);
        this.handleBestPrice.bind(this);
        this.handelChangeSearch.bind(this);
        this.state = {
            loading: false,
            data: null,
            airports: [],
            time1: true,
            time2: true,
            time3: true,
            time4: true,
            flight_number: 0,
            flights: [],
            flights_filterd: [],
            airlines_selected: [],
            airlines: ["IR", "W5", "QB", "HH"],
            prev_airlines: [],
            prev_time: [],
            flightType: ["charter", "Standard"],
            is_authenticated: false,
            sortBy: null,//price - time
            sortASC: true,//asc - desc
            searchDate: null,
            dayBefore: null,
            dayAfter: null,
            dayArray: [],
            bestLoader: false,
            bestPrice: [],
            showSearch: false,
            reload: false,
            intervalId: true,
            timefilter: true,
            airlinefilter: true,
            flighttypefilter: true,
            timeout: false,
        }
        moment.locale('en')
    }

    async componentDidMount() {

        try {
            const data = await this.props.search;
            const airports = await this.props.airports;
            // console.log(data)
            await this.setState({ data, airports, airlines_selected: airlines_selected });
            await this.calculateDates();
            await this.handleRequest();
            await this.handleBestPrice();
            setTimeout(() => this.setState({ timeout: true }), 600000);

            // this.timer = setInterval(
            //     () => this.setState(prevState => ({ reload: !prevState.reload })),
            //     5000,
            // );

            // var intervalId = setInterval(this.timer, 1000);
            // // store intervalId in the state so it can be accessed later:
            // this.setState({ intervalId: intervalId });

            // setInterval(function () {
            //     () => { this.setState({ reload: true }) }

            //     // alert('Your time for Booking is Finish')
            //     // window.location.reload();

            // },
            //     // 480000
            //     1000
            // );

        } catch (e) {
            console.log(e);
            // window.location.replace("/");
        }
        this.setState({ loading: true });
    }

    // componentWillUnmount() {
    //     // use intervalId from the state to clear the interval
    //     clearInterval(this.state.intervalId);
    // }

    // timer() {
    //     // setState method is used to update the state
    //     this.setState({ reload: true });
    // }



    render() {
        // console.log(this.props.search)
        // console.log('Render_time')

        const start_location_one_way = airports.filter(item => item.iata === this.props.search.OriginDestinationInformation[0].OriginLocation.Code)[0];
        const end_location_one_way = airports.filter(item => item.iata === this.props.search.OriginDestinationInformation[0].DestinationLocation.code)[0];
        const selected_date = this.props.search.OriginDestinationInformation[0].DepartureDate
        // console.log(selected_date)
        // console.log(localStorage.getItem('altrabo_api_token'))

        // const { reload } = this.state
        console.log(this.state.flights);

        return (
            <div className="pt-5 mt-5">

                {this.state.timeout &&
                    <Modal isOpen className='modal-refresh' >
                        <div className='refresh-page'>
                            <ModalHeader >
                                Opration TimeOut
                            </ModalHeader>
                            <ModalBody>
                                <p>
                                    The validity period of the search results has expired.
                                </p>
                                <p>
                                    In order to update prices and flights, please do your search from the beginning.
                                </p>
                                <div className='refresh_butoon_modal' >
                                    <Button onClick={() => window.location.reload()} >
                                        Refresh
                                </Button>
                                </div>
                            </ModalBody>
                        </div>
                    </Modal>
                }
                <Container className="min-height-500">
                    {/* <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Search flight</BreadcrumbItem>
                    </Breadcrumb> */}

                    <Row>
                        <Col>
                            {/* <SaveLoader type="spinningBubbles" color="#43b185" /> */}

                            {!this.state.loading ?
                                // <SaveLoader type="spinningBubbles" color="#43b185" />
                                ""
                                :
                                <div className="collsapse-bokk-ticket">
                                    <div className="today-and-search-again">
                                        <div className="your-selection-city-date">
                                            <span className="your-selection-city-date-from">From :
                                                 &nbsp;{start_location_one_way.city}
                                            </span>
                                            <span className="your-selection-city-date-to" >To : &nbsp; {end_location_one_way.city} </span>
                                            <span className="your-selection-city-date-date" >Date : &nbsp; {selected_date} </span>
                                        </div>
                                        <div className="your-selection-city-date-but">
                                            <Button block outline color="secondary" className='search-again-but' onClick={() => this.setState({ showSearch: !this.state.showSearch })}>
                                                {!this.state.showSearch ? "Search Again" : "Hide Search"}
                                            </Button>
                                        </div>
                                    </div>
                                    <Collapse isOpen={this.state.showSearch}>
                                        <Card className='search-again-card'>
                                            <CardBody  >
                                                <BannerLink airports={this.props.airports} selectedairports={this.props.selectedairports} />
                                            </CardBody>
                                        </Card>
                                        {/* <Card>
                                            <CardBody>
                                                <AirplaneSearchForm airports={this.state.airports} data={this.state.data} search={this.handelChangeSearch.bind(this)} />
                                            </CardBody>
                                        </Card> */}
                                    </Collapse>
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <Steppers active={0} />
                            </div>
                        </Col>
                    </Row>
                    {/* {this.state.reload === true ? 'true' : 'false'} */}
                    {!this.state.loading ? <SaveLoader
                        // type="spinningBubbles"
                        color="#43b185" /> :
                        <Row className='mt-3 md-5'>
                            <Col md='3' sm='12' className="filter-left-sidebar">
                                <div className="panel panel-default sidebar-menu box p-3 pt-4" >
                                    <div className="panel-body">


                                        {/* <hr /> */}
                                        <div className="category-title pb-1">
                                            <Card className="filter-title-collapse">
                                                <CardBody>
                                                    <h6 onClick={() => this.setState(prestate => ({ timefilter: !prestate.timefilter }))}> Time to travel :</h6>
                                                </CardBody>
                                            </Card>
                                            <Collapse isOpen={this.state.timefilter} className="collapse-filter-body">
                                                <Card>
                                                    <CardBody>
                                                        <div className="w-100 d-flex filter-flight-time">
                                                            <Button outline color="secondary" className={this.state.time1 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelSelectTime.bind(this, "time1")}><span className="time-travel-span">0 to 8 </span><br />AM</Button>
                                                            <Button outline color="secondary" className={this.state.time2 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelSelectTime.bind(this, "time2")}><span className="time-travel-span">8 to 12 </span><br />AM</Button>
                                                            <Button outline color="secondary" className={this.state.time3 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelSelectTime.bind(this, "time3")}><span className="time-travel-span">12 to 20</span> <br />PM</Button>
                                                            <Button outline color="secondary" className={this.state.time4 ? "filter-item-flight-time active" : "filter-item-flight-time"} onClick={this.handelSelectTime.bind(this, "time4")}><span className="time-travel-span">20 to 24</span> <br />PM</Button>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Collapse>
                                            <Card className="filter-title-collapse">
                                                <CardBody>
                                                    <h6 onClick={() => this.setState(prestate => ({ airlinefilter: !prestate.airlinefilter }))}>Airline Company :</h6>
                                                </CardBody>
                                            </Card>
                                            <Collapse isOpen={this.state.airlinefilter} className="collapse-filter-body">
                                                <Card>
                                                    <CardBody>
                                                        <div className="w-100 ">
                                                            {airlines_selected.map(item =>
                                                                <FormGroup check key={item.id} style={{ paddingLeft: 0 }} >
                                                                    <Label check>
                                                                        <Checkbox
                                                                            // color="default"
                                                                            onChange={this.handleToggle.bind(this, item.iata)}
                                                                        // checked={this.state.airlines !== -1}
                                                                        />

                                                                        <img src={`./../../assets/images/${item.icon}`} alt={item.name} className='filter-icon' />

                                                                        {item.name}
                                                                    </Label>
                                                                </FormGroup>
                                                            )}
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Collapse>
                                            <Card className="filter-title-collapse">
                                                <CardBody>
                                                    <h6 onClick={() => this.setState(prestate => ({ flighttypefilter: !prestate.flighttypefilter }))}>Flight type :</h6>
                                                </CardBody>
                                            </Card>
                                            <Collapse isOpen={this.state.flighttypefilter} className="collapse-filter-body">
                                                <Card>
                                                    <CardBody>
                                                        <div className="w-100 ">
                                                            <FormGroup check style={{ paddingLeft: 0 }}>
                                                                <Label check>
                                                                    <Checkbox
                                                                        color="default"
                                                                        onChange={this.changeType.bind(this, "charter")}
                                                                        checked={this.state.flightType.indexOf("charter") !== -1}
                                                                    />
                                                                    Charter
                                                </Label>
                                                            </FormGroup>
                                                            <FormGroup check style={{ paddingLeft: 0 }} >
                                                                <Label check>
                                                                    <Checkbox
                                                                        color="default"
                                                                        onChange={this.changeType.bind(this, "Standard")}
                                                                        checked={this.state.flightType.indexOf("Standard") !== -1}
                                                                    />
                                                                    Standard
                                                </Label>
                                                            </FormGroup>

                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </Collapse>

                                        </div>
                                    </div>

                                </div>
                            </Col>
                            <Col md='9' sm='12' >
                                <div className='white mb-3 box w-100 d-flex'>
                                    {!this.state.bestLoader ?
                                        // <SectionLoader type="spinningBubbles" color="#43b185" />
                                        ""
                                        :
                                        <div className="w-100 d-flex">
                                            {this.state.dayArray.map((item, index) =>
                                                <Button
                                                    // outline={!item.isCurrent}
                                                    disabled={!item.isActive}
                                                    color="link"
                                                    key={index}
                                                    className={!item.isCurrent ? "flex-fill bestPrice-btn" : "flex-fill bestPrice-btn current"}
                                                    onClick={this.handelChangeDate.bind(this, item.keyDate)}>
                                                    <div className="bestPrice-inner">
                                                        <span className="bestPrice-date">{item.date}</span>
                                                        <PriceFormatter
                                                            className="bestPrice-price"
                                                            data={this.state.bestPrice[item.keyDate]}
                                                            type="airplane"
                                                            date={item.keyDate}
                                                        />
                                                    </div>

                                                </Button>
                                            )}
                                        </div>}
                                </div>
                                <div className='white box mb-3 w-100'>
                                    <Col className='pt-2 pb-2'>
                                        <div className='d-flex justify-content-between w-100 search-filter-bar'>
                                            <span>{this.state.flights_filterd.length} flight(s) find.</span>

                                            <ButtonGroup>
                                                <Button outline color="secondary" className={(this.state.sortBy === "price") ? "activeSort" : "inactiveSort"} onClick={this.handelSort.bind(this, "price")}>
                                                    <i className={(this.state.sortBy === "price" && this.state.sortASC) ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc"} /> Price
                                            </Button>

                                                <Button outline color="secondary" className={(this.state.sortBy === "time") ? "activeSort" : "inactiveSort"} onClick={this.handelSort.bind(this, "time")}>
                                                    <i className={(this.state.sortBy === "time" && this.state.sortASC) ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc"} /> Flight time
                                            </Button>
                                            </ButtonGroup>

                                            <ButtonGroup>
                                                <Button outline color="secondary" onClick={this.handelChangeDate.bind(this, this.state.dayBefore)}>
                                                    {/*{this.state.dayBefore}*/}
                                                    <i className="la la-chevron-left" />
                                                </Button>
                                                <Button disabled outline color="secondary" >{this.state.searchDate}</Button>
                                                <Button outline color="secondary" onClick={this.handelChangeDate.bind(this, this.state.dayAfter)}>
                                                    {/*{this.state.dayAfter}*/}
                                                    <i className="la la-chevron-right" />
                                                </Button>
                                            </ButtonGroup>

                                        </div>
                                    </Col>

                                </div>
                                {this.state.flights_filterd.map((item, index) => {
                                    let adultNo = 0;
                                    let childNo = 0;
                                    let infantNo = 0;

                                    this.state.data.TravelerInfoSummary.AirTravelerAvail.map(item => {
                                        if (item.PassengerType === 1) {
                                            adultNo += parseInt(item.Quantity, 10);
                                        } else if (item.PassengerType === 2) {
                                            childNo += parseInt(item.Quantity, 10);
                                        } else {
                                            infantNo += parseInt(item.Quantity, 10);
                                        }
                                        return null;
                                    });
                                    moment.defaultFormat = "DD MMM YYYY HH:mm:ss";

                                    let leaveOptions = item.airItinerary.leaveOptions[0];
                                    let flightSegments = leaveOptions.flightSegments[0];
                                    //arival
                                    let arrivalAirport = airports.filter(item => item.iata === flightSegments.arrivalAirport.code)[0];
                                    let arrivalDate = moment(flightSegments.arrivalDate, moment.defaultFormat).format('dd DD MMM');//19 Jan 2019 23:19:00
                                    let arrivalTime = moment(flightSegments.arrivalDate, moment.defaultFormat).format('HH:mm');
                                    //departure
                                    let departureAirport = airports.filter(item => item.iata === flightSegments.departureAirport.code)[0];
                                    let departureTime = moment(flightSegments.departureDate, moment.defaultFormat).format('HH:mm');

                                    let flightNumber = flightSegments.flightNumber;


                                    let bookingClassAvail = flightSegments.bookingClassAvail;
                                    let equipment = flightSegments.equipment;
                                    let isChartered = leaveOptions.isChartered;
                                    // let baggages=  flightSegments.baggages;
                                    let resBookDesigQuantity = leaveOptions.resBookDesigQuantity;
                                    let price = item.airItineraryPricingInfo;

                                    let adultFare = 0;
                                    let adultFareT = 0;
                                    let childFare = 0;
                                    let childFareT = 0;
                                    let infantFare = 0;
                                    let infantFareT = 0;
                                    price.ptcFareBreakdowns.map(it => {
                                        let item = it.passengerFares[0];
                                        if (item.passengerTypeQuantity.passengerType === "Adult") {
                                            adultFare = item.baseFare.amount;
                                            adultFareT = item.totalFare.amount;
                                        } else if (item.passengerTypeQuantity.passengerType === "Child") {
                                            childFare = item.baseFare.amount;
                                            childFareT = item.totalFare.amount;
                                        } else {
                                            infantFare = item.baseFare.amount;
                                            infantFareT = item.totalFare.amount;
                                        }
                                        return null;
                                    });
                                    let ticket = {
                                        isDomestic: item.isDomestic,
                                        departureAirport: flightSegments.departureAirport.code,
                                        arrivalAirport: flightSegments.arrivalAirport.code,
                                        departureDate: flightSegments.departureDate,
                                        arrivalDate: flightSegments.arrivalDate,
                                        airLine: flightSegments.marketingAirLine.code,
                                        bookingClassAvail: bookingClassAvail.cabinType,
                                        airEquipType: equipment.airEquipType,
                                        airEquipName: equipment.name,
                                        flightNumber: flightNumber,
                                        flightDuration: flightSegments.flightDuration,
                                        isChartered: isChartered,
                                        isRefundable: leaveOptions.isRefundable,
                                        availableSeat: resBookDesigQuantity,
                                        airItineraryRph: item.airItinerary.airItineraryRph,
                                        baseFare: price.itinTotalFare.baseFare.amount,
                                        totalFare: price.itinTotalFare.totalFare.amount,
                                        adultFare,
                                        adultFareT,
                                        childFare,
                                        childFareT,
                                        infantFare,
                                        infantFareT,
                                    };
                                    let airLine = {
                                        "name": "unknown",
                                        "iata": flightSegments.marketingAirLine.code,
                                        "icon": "airline/icon.png",
                                    };
                                    let airlineByFilter = airlines.filter(item => item.iata === flightSegments.marketingAirLine.code);
                                    if (airlineByFilter.length > 0) {
                                        airLine = airlineByFilter[0];
                                    }
                                    return (
                                        <FlightItem
                                            key={index}
                                            data={item}
                                            formData={this.state.data}
                                            adultNo={adultNo}
                                            childNo={childNo}
                                            infantNo={infantNo}
                                            ticket={ticket}
                                            departureAirport={departureAirport}
                                            arrivalAirport={arrivalAirport}
                                            arrivalDate={arrivalDate}
                                            arrivalTime={arrivalTime}
                                            departureTime={departureTime}
                                            airLine={airLine}
                                            iata={airLine.iata}
                                            orgTicket={item}

                                        />
                                    )
                                }
                                )}
                            </Col>

                        </Row>
                    }
                </Container>
            </div>
        );
    }

    async handelChangeSearch(data) {
        await this.setState({ data });
        await this.calculateDates();
        await this.handleRequest();
    }
    async handelChangeDate(date) {
        // console.log(date)
        let newData = await this.state.data;
        await this.setState({
            data: {
                ...newData,
                OriginDestinationInformation: [
                    {
                        ...newData.OriginDestinationInformation[0],
                        "DepartureDate": date
                    }
                ]
            }
        });
        const data_search = {
            ...newData,
            OriginDestinationInformation: [
                {
                    ...newData.OriginDestinationInformation[0],
                    "DepartureDate": date
                }
            ]
        }
        this.props.setSearch(data_search);
        await this.calculateDates();
        await this.handleRequest();
    }
    async calculateDates() {
        const { data } = await this.state;
        let refDate = moment(data.OriginDestinationInformation[0].DepartureDate, "YYYY-M-D");

        let searchDate = refDate.format("DD MMM YYYY");
        let dayAfter = refDate.add(1, 'days').format("YYYY-M-D");
        let dayBefore = refDate.subtract(2, 'days').format("YYYY-M-D");
        let today = moment().format("DD MMM YYYY");
        let dayArray = [];
        let tempDate = moment(data.OriginDestinationInformation[0].DepartureDate, "YYYY-M-D").subtract(4, 'days');

        for (let i = 1; i < 8; i++) {
            let newDate = tempDate.add(1, 'day');
            let tDate = newDate.format("dddd - DD MMM");
            let keyDate = newDate.format("YYYY-M-D");
            let dayOfWeek = newDate.format("dddd");
            let isActive = !newDate.isBefore(today);
            let isCurrent = newDate.isSame(searchDate);

            dayArray.push({
                date: tDate,
                keyDate,
                dayOfWeek,
                isActive,
                isCurrent
            });
        }
        this.setState({ searchDate, dayBefore, dayAfter, dayArray });
    }
    async handelSort(sortBy) {
        let flight = this.state.flights_filterd;
        let sortASC = true;
        if (this.state.sortBy === sortBy) {
            sortASC = !this.state.sortASC;
        }
        this.setState({ sortASC, sortBy });
        if (sortBy === 'price') {
            flight.sort((a, b) => parseFloat(a.airItineraryPricingInfo.itinTotalFare.baseFare.amount) - parseFloat(b.airItineraryPricingInfo.itinTotalFare.baseFare.amount));
        } else {
            //time
            flight.sort((a, b) => this.compareTime(a, b));
        }

        if (!sortASC) {
            flight.reverse();
        }

    }
    compareTime(a, b) {
        let aTime = a.airItinerary.leaveOptions[0].flightSegments[0].departureDate;
        let bTime = b.airItinerary.leaveOptions[0].flightSegments[0].departureDate;

        let comparison = 0;
        if (moment(aTime) > moment(bTime)) {
            comparison = 1;
        } else if (moment(aTime) < moment(bTime)) {
            comparison = -1;
        }
        return comparison;
    }
    async handelSelectTime(newtime) {
        // console.log(newtime)
        const allfalse = { time1: false, time2: false, time3: false, time4: false };
        const alltrue = { time1: true, time2: true, time3: true, time4: true };
        let time = {};
        const prev_time = this.state.prev_time;

        if (prev_time.filter((item) => item === newtime).length !== 0) {
            let index = prev_time.indexOf(newtime);
            prev_time.splice(index, 1);
            if (prev_time.length === 0) {
                time = alltrue;
            } else {
                time = allfalse;
                prev_time.map(ptime => time[ptime] = true);
            }

            await this.setState(time)

        } else {
            prev_time.push(newtime);
            if (prev_time.length === 4) {
                time = alltrue;
                this.setState({ prev_time: [] })
            } else {
                time = allfalse;
                prev_time.map(ptime => time[ptime] = true);

            }
            await this.setState(time)
        }

        console.log(prev_time);
        // console.log(time);

        await this._handleFilterd();
    }
    async handleToggle(iata) {
        let prev_airlines = this.state.prev_airlines
        let airlines = this.state.airlines;

        if (prev_airlines.filter((item) => item === iata).length !== 0) {
            let index = prev_airlines.indexOf(iata);
            prev_airlines.splice(index, 1);
            airlines.splice(index, 1);
            await this.setState({ airlines })
            if (prev_airlines.length === 0)
                await this.setState({ airlines: ["IR", "W5", "QB", "HH"] })
        } else {
            prev_airlines.push(iata);
            if (airlines.filter((item) => item === iata).length === 0) {
                airlines.push(iata);
                await this.setState({ airlines })
            } else {
                await this.setState({ airlines: [iata] })
            }
            await this.setState({ prev_airlines })
        }
        await this._handleFilterd();
    }
    async changeType(type) {
        let flightType = this.state.flightType;
        let index = flightType.indexOf(type);
        if (index !== -1) {
            flightType.splice(index, 1);
        } else {
            flightType.push(type)
        }
        await this.setState({ flightType });
        await this._handleFilterd();

    }

    async _handleFilterd() {
        let flights = this.state.flights;
        if (!(this.state.time1 && this.state.time2 && this.state.time3 && this.state.time4)) {
            let time_array = [];
            if (this.state.time1) {
                time_array.push({ "start": "00:00", "end": "8:00" });
            }
            if (this.state.time2) {
                time_array.push({ "start": "8:00", "end": "12:00" });
            }
            if (this.state.time3) {
                time_array.push({ "start": "12:00", "end": "20:00" });
            }
            if (this.state.time4) {
                time_array.push({ "start": "20:00", "end": "24:00" });
            }
            let newFlight = [];

            flights.map(item => {
                // let departureDate = moment(item.airItinerary.leaveOptions[0].flightSegments[0].departureDate).tz('Asia/Tehran').format('HH:mm');
                let departureDate = moment(item.airItinerary.leaveOptions[0].flightSegments[0].departureDate).format('HH:mm');
                for (let i = 0; i < time_array.length; i++) {
                    let compare = (moment(departureDate, "HH:mm") > moment(time_array[i].start, "HH:mm")) && (moment(departureDate, "HH:mm") <= moment(time_array[i].end, "HH:mm"));
                    if (compare) {
                        newFlight.push(item);
                    }
                }
                return true;
            });
            flights = newFlight;
        }
        if (this.state.airlines.length < 4) {
            let newFlight = [];
            flights.map(item => {
                let flight_ita = item.airItinerary.leaveOptions[0].flightSegments[0].marketingAirLine.code;
                if (this.state.airlines.indexOf(flight_ita) !== -1) {
                    newFlight.push(item);
                }
                // return item;
                return true;
            });
            flights = newFlight;
        }
        if (this.state.flightType.length < 2) {
            let newFlight = [];
            flights.map(item => {
                let isChartered = item.airItinerary.leaveOptions[0].isChartered;
                if (this.state.flightType.length !== 0) {
                    if (this.state.flightType[0] === "charter") {
                        if (isChartered) {
                            newFlight.push(item);
                        }
                    } else {
                        if (!isChartered) {
                            newFlight.push(item);
                        }
                    }
                }
                // return item;
                return true;
            });
            flights = newFlight;
        }

        this.setState({ flights_filterd: flights });
    }
    async handleRequest() {
        this.setState({ loading: false });
        try {
            const { data } = this.state;
            let access_token = localStorage.getItem(ACCESS_TOKEN);

            const options = {
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    'X-ZUMO-AUTH': access_token,
                    'Content-Type': 'application/json',

                },
                data: qs.stringify(data),
                url: `${ALIBABA_URL}Available/Get`,
            };

            // let response = await axios.post(`${ALIBABA_URL}token`,data,config);
            let response = await axios(options);
            // console.log(response)
            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error('An error occurred while receiving information from the server.', {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: false
                });
            } else {
                let data = response.data.data.pricedItineraries;
                let count = response.data.data.count;
                // console.log(data);
                this.setState({
                    flights: data,
                    flights_filterd: data,
                    flight_number: count
                })
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
            }
        }
        this.setState({ loading: true });
    };
    async handleBestPrice() {
        try {
            const { data } = this.state;
            let access_token = localStorage.getItem(ACCESS_TOKEN);
            let fromIata = data.OriginDestinationInformation[0].OriginLocation.Code;
            let toIata = data.OriginDestinationInformation[0].DestinationLocation.code;

            const options = {
                method: 'GET',
                headers: {
                    'X-ZUMO-AUTH': access_token,
                    'Content-Type': 'application/json',
                },
                url: `${ALIBABA_URL}Available/GetFlightPriceCalendar?FromAirportIata=${fromIata}&ToAirportIata=${toIata}`,
            };

            let response = await axios(options);

            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                toast.error('An error occurred while receiving information from the server.', {
                    autoClose: 3000,
                    position: toast.POSITION.TOP_RIGHT,
                    rtl: false
                });
            } else {
                let bestPrice = response.data.data;
                //convert to key value array
                let price_array = [];
                bestPrice.map(item => {
                    let departureDate = moment(item.departureDate, "D MMM YYYY HH:mm:ss").format("YYYY-M-D");
                    price_array[departureDate] = item.minPrice;
                    return null;
                });

                this.setState({
                    bestPrice: price_array
                })
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                // let statusText = await apiError.statusText;
            }
        }
        this.setState({ bestLoader: true });
    };
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        search: state.search,
        airports: state.airports,
        selectedairports: state.selectedairports
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setSearch: search => {
            dispatch(setSearch(search))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/containers/search/Search.js